<template>
  <div class="experience infoPub">
    <el-col class="infoPub" style="width: 990px">
  
      <!-- 搜索组件 -->
      <search-bar
        :selectType="ExhIndexType"
        :searchInputPlc="language.studioFairName"
        :searchSelectPlc="language.exhibitionState"
        @changeExhibitionState="toSearch"
        @toSearch="toSearch"
      ></search-bar>
       <!--提示信息-->
      <!-- <div class="prompt-info" v-if="lan=='ch'" style="padding-top:15px;margin-top:10px;">1、请点击“我要布展”，完善您的展位英文信息，以便海外客户与您对接。</div> -->
      <div class="prompt-info" v-if="lan=='ch'">1、参展前，请确保您使用的参展电脑配有摄像头，耳机和麦克风设备。</div>
      <div class="prompt-info" style="padding-bottom:15px;" v-if="lan=='ch'">2、参展时，请使用谷歌浏览器打开展会官网，如需安装，<span class="download" @click="download"> {{language.down}} </span></div>
      <div class="prompt-info" v-if="lan=='en'" style="padding-top:15px;margin-top:10px;">Please make sure your facilities for meeting are ready before meeting start.</div>
      <div class="prompt-info" v-if="lan=='en'" >1.Your laptop or computer with camera, headset and microphone.</div>
      <div class="prompt-info" style="padding-bottom:15px;" v-if="lan=='en'">2.Using latest version of Google Chrome browser.<span class="download" @click="download"> Click to download Chrome. </span></div>
      <!-- 列表组件 -->
      <!-- @selectContact="selectContact" -->
      <otolistexperience
        :listData="cloneListData"
        @changData="handleBeh"
        @joinData="joinData"
        @showImg="showImg"
        @showBroadcast="showBroadcast"
        v-loading="loading"
        :language="language"
      ></otolistexperience>
      <!-- page -->
      <table-page
        jumpColor="white"
        :pageSize="pageSize"
        :layout="layout"
        :pageTotal="pageTotal"
        :currentPage="currentPage"
        @pageChange="pageChange"
      ></table-page>
    </el-col>
    <!-- 修改弹窗 -->
    <dialog-pub
      ref="dialogChild"
      class="dislogCon"
      exTop="8vh"
      :title="title"
      :dialogFormVisible="dialogFormVisible"
    >
    <div class="prompt-info" v-if="lan=='ch'" style="padding-left:0;margin-bottom:10px;">请完善您的英文信息，方便海外对接。</div>
      <el-form :model="form">
        <el-form-item :label="language.newStudioName+language.chineseName+':'" :label-width="formLabelWidth">
          <el-input style="width:369px" v-model="form.broadcast_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="language.newStudioName+language.englishName+':'" :label-width="formLabelWidth">
          <el-input style="width:369px" v-model="form.broadcast_name_en" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="language.userPost+language.chineseName+':'" :label-width="formLabelWidth">
          <el-input style="width:369px" v-model="form.user_post" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="language.userPost+language.englishName+':'" :label-width="formLabelWidth">
          <el-input style="width:369px" v-model="form.user_post_en" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="language.nickName+language.chineseName+':'" :label-width="formLabelWidth">
          <el-input style="width:369px" v-model="form.truename" autocomplete="off" readonly="readonly"></el-input>
        </el-form-item>
        <el-form-item :label="language.nickName+language.englishName+':'" :label-width="formLabelWidth">
          <el-input style="width:369px" v-model="form.truename_en" autocomplete="off" readonly="readonly"></el-input>
        </el-form-item>
        <el-form-item :label="language.classification+':'" :label-width="formLabelWidth">
          <el-select
            style="width:369px"
            v-model="form.broadcast_class_id"
            :placeholder="language.exhibitionSelect"
          >
            <el-option
              v-for="(item,index) in broadClass"
              :key="index"
              :label="item.broadcast_class_name?item.broadcast_class_name:item.broadcast_class_name_en"
              :value="item.broadcast_class_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="language.contact+':'" :label-width="formLabelWidth">
          <el-input style="width:369px" v-model="form.broadcast_contact" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="language.newKeyWord+language.chineseName+':'" :label-width="formLabelWidth">
          <el-input style="width:369px" v-model="form.keyword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="language.newKeyWord+language.englishName+':'" :label-width="formLabelWidth">
          <el-input style="width:369px" v-model="form.keyword_en" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="language.companyLogo+':'" :label-width="formLabelWidth">
          <el-upload
            :action="fileUpload"
            class="uploadImg"
            list-type="picture-card"
            :on-success="updateSuccess"
            :before-upload="onBeforeUpload"
            :on-remove="handleRemove"
            :on-preview="handlePictureCardPreview"
            :limit="1"
            :file-list="imgList"
            accept=".jpg, .jpeg, .png, .JPG, .JPEG, .gif"
          >
            <div class="upText">
              <div>{{language.click}}</div>
              <div>{{language.uploadLogo}}</div>
            </div>
          </el-upload>
          <div
            style="font-size:12px;color:#424242;padding-left:22px"
          >{{language.suggestSize}}160*160px</div>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="formBtn" @click.native="ok">{{language.submit}}</el-button>
        <el-button class="formBtn" type="primary" @click.native="cancel">{{language.cancel}}</el-button>
      </div>
    </dialog-pub>
    <!-- 查看大图 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="form.broadcast_logo" alt />
    </el-dialog>
    
    <!-- 邀请码分享 -->
    <el-dialog
        title=""
        :visible.sync="showImgDialogFormVisible"
        width="1200px"
        top="10vh"
        class="dislogCon-Img"  style="margin: 0 auto;text-align:center;">
        <!-- <img :src="imgSrc" alt="" style="margin: 0 auto;text-align:center;"> -->
        <div class="img-wrap">
            <div class="img-wrap-left">
                <img class="choose-img" :src="imgSrcList[imgSrcIndex]" alt="">
            </div>
            <div class="img-wrap-right">
                <div class="img-wrap-title">
                    <p>制作手机海报分享</p>
                    <div class="div-border-bottom-color"></div>
                </div>
                <div class="img-wrap-right-top">
                    <div :class="imgSrcIndex == index ? 'img-wrap-right-top-div img-wrap-right-top-div-active' : 'img-wrap-right-top-div' " v-for="(item, index) in imgSrcList" :key="index">
                        <img :src="item" alt="" @click="changeImgSrc(index)">
                        <img v-if="imgSrcIndex == index" class="img-right" src="../../../assets/icon-right.png" alt="">
                    </div>
                </div>
                <div class="img-formBtn">
                    <el-button class="img-down-formBtn" @click.native="imgDown">下载</el-button>
                    <el-button class="img-camcale-formBtn" type="primary" @click.native="cancelImg">取消</el-button>
                </div>
            </div>
        </div>
    </el-dialog>

    <line-dialog :show.sync="visibleLine" :lan="language" :waitData="waitData" :lanState="lan" />
    <download-dialog :show.sync="downloadShow" />
  </div>
</template>
<script>
import reqest from "@/common/reqest";
import { language } from "../../../language/get";
import searchBar from "../components/searchbar/searchbar";
import otolistexperience from "../components/otolistexperience/otolistexperience";
import tablePage from "../components/tablepage/tablepage";
import dialogPub from "../components/dialogpub/dialogpub";
import { getLiveUrl, selectContact } from "../../../api/forum";
import { mapGetters } from "vuex";
const pubLanguage = language();
import { ExhIndexType } from "../../../common/constant/exhibition";
import Cookie from "../../../common/cookie";
import downloadDialog from "../../../components/DownloadDialog/index";
import {
  getBroadcastList,
  getBroadcastClass,
  editBroadcastList,
  toggleBroadcast,
  BroadcastExperienceList,
} from "../../../api/btManage";
import { isEmpty, isInternet } from "../../../common/validate";
import { goRoom } from "../../../api/webSocket";
import lineDialog from "../../../components/LineDialog";
import { roomUrl, windowsGoTo } from "../../../common/url";
import axios from "axios";

export default {
  computed: {
    ...mapGetters(["token", "userInfo"])
  },
  components: {
    searchBar,
    otolistexperience,
    tablePage,
    dialogPub,
    lineDialog,
    downloadDialog
  },
  data() {
    return {
      fileUpload: reqest.apiUrl+'/Home/Publicother/uplodadLogo',
      exhibition_id: "",
      loading: false,
      ExhIndexType,
      //弹窗
      title: pubLanguage.editeStudio,
      //图片上传
      dialogVisible: false,
      imgList: [],
      dialogFormVisible: false,
      form: {
        exhibition_id: "",
        exh_user_id: "",
        broadcast_id: "",
        broadcast_class_id: "",
        broadcast_name: "",
        broadcast_name_en: "",
        location: "",
        location_en: "",
        company: "",
        company_en: "",
        user_post: "",
        user_post_en: "",
        truename: "",
        truename_en: "",
        broadcast_class_name: "",
        tel: "",
        broadcast_introduce: "",
        broadcast_introduce_en: "",
        broadcast_logo: "",
        broadcast_contact: "",
        keyword: "",
        keyword_en: ""
      },
      formLabelWidth: "28%",
      language: language(),
      lan: Cookie.get("lang"),
      broadClass: [],
      listData: [],
      cloneListData: [],
      //page
      pageTotal: 0,
      pageSize: 4,
      currentPage: 1,
      layout: "prev, pager, next, jumper",
      //搜索条件
      getStateCon: null,
      getValCon: null,
      //排队
      visibleLine: false,
      waitData: {},
      downloadShow: false,
      
      
      imgSrcList: [],
      imgSrcIndex: 0,
      showImgDialogFormVisible: false,
    };
  },
  created() {
    //this.broadcastClass();
  },
  methods: {
    //update
    onBeforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 2;
      if (!isLt1M) {
        this.$message({
          showClose: true,
          message: this.language.fileMaxSize,
          type: "error",
          offset: "120"
        });
      }

      return isLt1M;
    },
    updateSuccess(res) {
      if (res.type == "1") {
        this.form.broadcast_logo = res.data.file.picurl;
      } else {
        if (this.lan == "ch") {
          return this.$message.error({ message: res.text, offset: 120 });
        }
        return this.$message.error({ message: res.text_en, offset: 120 });
      }
    },
    handleRemove() {
      this.form.broadcast_logo = "";
    },
    handlePictureCardPreview(file) {
      this.form.broadcast_logo = file.url;
      this.dialogVisible = true;
    },
    //修改赋值
    handleBeh(state, id, item) {
     // console.log(item)
      if (state == 1) {
      
        this.exhibition_id = item.exhibition_id;
        this.broadcastClass();
        this.$refs.dialogChild.receiveDialogFormVisible = true;
        let editDataList = item;
        console.log(editDataList);
        for (let editDataListKey in editDataList) {
          for (let formKey in this.form) {
            if (editDataListKey === formKey) {
              this.form[formKey] = editDataList[editDataListKey];
            }
          }
        }
        this.form.broadcast_logo = editDataList.broadcast_logo;
        if (
          this.form.broadcast_logo != null &&
          !isEmpty(this.form.broadcast_logo)
        ) {
          this.imgList = [{ status: "success", url: this.form.broadcast_logo }];
        } else {
          this.imgList = [];
        }
        this.dialogFormVisible = true;
        return;
      }
     
    },
    joinData(state, id, item){
       if (!isInternet()) {
        return (this.downloadShow = true);
      }
      const props = {
        token: this.token,
        broadcast_id: id
      };
      this.$store
        .dispatch("getLiveInfo", props)
        .then(res => {
          if (res.type != "1") {
            if (isEmpty(res.data)) {
              if (this.lan == "ch") {
                return this.$message.error({ message: res.text, offset: 120 });
              } else {
                this.$message.error({ message: res.text_en, offset: 120 });
              }
              return;
            }
            const data = res.data[0];
            if (data.type != 1) {
              if (this.lan == "ch") {
                return this.$message.error({ message: res.text, offset: 120 });
              } else {
                this.$message.error({ message: res.text_en, offset: 120 });
              }
              return;
            }
            const waitData = {
              token: this.token,
              roomid: data.roomid
            };
            //需要排队
            if (res.data[0].type == 1) {
              this.waitData = waitData;
              this.visibleLine = true;
            }
            return;
          }
          const data = res.data[0];

          // console.log(data);
          // return;
          // return (window.location.href =
          //   windowsGoTo() + roomUrl(data, this.userInfo.true_name));
          //   return(window.open(windowsGoTo() + roomUrl(data, this.userInfo.true_name)))
          let name = Cookie.get("lang") == 'ch' ? (this.userInfo.true_name || this.userInfo.true_name_en) : (this.userInfo.true_name_en || this.userInfo.true_name);
          window.location.href = windowsGoTo() + roomUrl(data, name);
        })
        .catch(() => {});
    },
    showBroadcast(e,i){
      var message = ''
      var paramsBroadcastShow = null;
      if(e.broadcast_show == 0){
        var message = '开启'
        paramsBroadcastShow = 1;
      }else{
        var message = '隐藏'
        paramsBroadcastShow = 0;
      }

      this.$confirm('确认' + message + '直播间?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            broadcast_id: e.broadcast_id,
            broadcast_show: paramsBroadcastShow,
          }
          toggleBroadcast(params).then(data => {
            if (data.type != 1) {
              if (this.lan == "ch") {
                return this.$message.error({ message: res.text, offset: 120 });
              } else {
                this.$message.error({ message: res.text_en, offset: 120 });
              }
              return;
            }
          })
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
          this.cloneListData[i].broadcast_show = paramsBroadcastShow;
        //  this.getList();
        }).catch(() => {

        });
    },
    
    // 查看联系方式
    // selectContact(e){
    //   let parmas = {
    //     token: this.token,
    //     broadcast_id: e.broadcast_id
    //   }
    //   selectContact(parmas)
    //       .then(res => {
    //           if (res.type != "1") {
    //               if (this.lan == "ch") {
    //                   return this.$message.error({ message: res.text, offset: 120 });
    //               }
    //               return this.$message.error({ message: res.text_en, offset: 120 });
    //           }
    //           this.$alert(
    //               res.data[0].broadcast_contact,
    //               this.language.hintContact,
    //               {
    //                   confirmButtonText: this.language.confirm,
    //                   callback: action => {}
    //               }
    //           );
    //       })
    //       .catch(() => {});
    // },
    
    //取消/关闭
    cancel() {
      this.$refs.dialogChild.receiveDialogFormVisible = false;
    },
    //确认修改
    ok() {
      
      this.editBroadcastList();
    },
    editBroadcastList() {
      let data = {
        token: this.token,
        broadcast_id: this.form.broadcast_id,
        broadcast_name: this.form.broadcast_name,
        broadcast_name_en: this.form.broadcast_name_en,
        broadcast_introduce: this.form.broadcast_introduce,
        broadcast_introduce_en: this.form.broadcast_introduce_en,
        user_post: this.form.user_post,
        user_post_en: this.form.user_post_en,
        truename: this.form.truename,
        truename_en: this.form.truename_en,
        company: this.form.company,
        company_en: this.form.company_en,
        broadcast_class_id: this.form.broadcast_class_id,
        broadcast_logo: this.form.broadcast_logo,
        location: this.form.location,
        location_en: this.form.location_en,
        broadcast_contact: this.form.broadcast_contact,
        keyword: this.form.keyword,
        keyword_en: this.form.keyword_en
      };
      editBroadcastList(data)
        .then(res => {
          if (res.type == "1") {
            this.$message({
              showClose: true,
              message: this.language.editSuccess,
              type: "success",
              offset: "100"
            });
            this.$refs.dialogChild.receiveDialogFormVisible = false;
            this.getList();
            let paramsData = {
              exh_user_id: this.form.exh_user_id,
              exhibition_id: this.form.exhibition_id,
            }
            this.showImg(paramsData);
          } else {
            if (this.lan == "ch") {
              return this.$message.error({ message: res.text, offset: 120 });
            }
            return this.$message.error({ message: res.text_en, offset: 120 });
          }
        })
        .catch(() => {});
    },
    //分页
    pageChange(val) {
      this.currentPage = val;
      this.getList();
    },
    //搜索切换
    toSearch(state, val) {
      this.getStateCon = state;
      this.getValCon = val;
      this.currentPage = 1;
      this.getList();
    },
    //获取直播间分类
    broadcastClass() {
      getBroadcastClass({ exhibition_id: this.exhibition_id }).then(res => {
        if (res.type != "1") {
          if (this.lan == "ch") {
            return this.$message.error({ message: res.text, offset: 120 });
          }
          return this.$message.error({ message: res.text_en, offset: 120 });
        }
        const data = res.data;
        this.broadClass = data;
      });
    },
    //下载谷歌浏览器
     download() {
       window.open("https://www.google.cn/intl/zh-CN/chrome/?brand=CHBD&gclid=EAIaIQobChMI_JKx1J2Z6QIVjqmWCh2-qwpkEAAYASAAEgKlBvD_BwE&gclsrc=aw.ds")
      },

    changeTime(time){
      var newdate = new Date(time);
      var YY = newdate.getFullYear();
      var MM = (newdate.getMonth() + 1).toString().length == 1 ? '0' + (newdate.getMonth() + 1) : (newdate.getMonth() + 1) ;
      var DD = newdate.getDate().toString().length == 1 ? '0' + newdate.getDate() : newdate.getDate();
      var hh = newdate.getHours().toString().length == 1 ? '0' + newdate.getHours() : newdate.getHours();
      var mm = newdate.getMinutes().toString().length == 1 ? '0' + newdate.getMinutes() : newdate.getMinutes();
      var ss = newdate.getSeconds().toString().length == 1 ? '0' + newdate.getSeconds() : newdate.getSeconds();
      
      return YY + '-' +  MM + '-' + DD + ' ' + hh + ':' + mm + ':' + ss;
    },


    getList() {
      let that = this;
      this.loading = true;
      let data = {
        token: this.token,
        broadcast_type: "1",
        type: "2",
        lan: this.lan,
        exhibitionState: this.getStateCon,
        keyword: this.getValCon,
        currentPage: this.currentPage,
        numberPage: this.pageSize
      };
      BroadcastExperienceList(data).then(res => {
        if (res.type == "1") {
          if (!res.data) {
            this.listData = [];
            this.cloneListData = [];
            this.pageTotal = res.datacount;
            this.loading = false;
            return false;
          }
          
          res.data.forEach(item => {
            if (this.lan == "en") {
              item.exh_name = `${item.exh_name_en}`;
              item.exh_begtime = `${item.exh_begtime_en}`;
              item.exh_endtime = `${item.exh_endtime_en}`;
              item.broadcast_name = `${item.broadcast_name_en}`;
              item.broadcast_introduce = `${item.broadcast_introduce_en}`;
              item.location = `${item.location_en}`;
              item.user_post = `${item.user_post_en}`;
              item.truename = `${item.truename_en}`;
              item.broadcast_class_name = `${item.broadcast_class_name_en}`;
            }
            // item.periodTime = `${this.language.localTime}：${item.exh_begtime} ${this.language.to} ${item.exh_endtime}`;
            item.periodTime = this.language.CreateTime + ': ' + this.changeTime(item.truetime*1000);
            // console.log(item.truetime)
            // console.log(item.periodTime)
            if(item.broadcast_type == 1){
              if (this.lan == "en") {
                var broadcast_type_name = "1V1";
              }
              else{
                var broadcast_type_name = "一对一";
              }
            }
            // if(item.broadcast_type == 2){
            //   if (this.lan == "en") {
            //     var broadcast_type_name = "Fourm";
            //   }
            //   else{
            //     var broadcast_type_name = "论坛";
            //   }
            // }
            
            item.broadcast_type_name = broadcast_type_name;
                
          });
          this.listData = res.data;
          this.loading = false;
          this.cloneListData = res.data;
          this.pageTotal = res.datacount * 1;
        } else {
          that.$message.error({
            message: res.text,
            offset: 100
          });
        }
      });
    },

    
    showImg(e){
      const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
      });
      let data = {
        exhibition_id: e.exhibition_id,
        broadcast_id: e.exh_user_id,
        currentTab: "1"
      };
      axios.post(reqest.adminapi+'MakeQr/getExhibitionRr', 
      // axios.post('http://exhixcx.shippingchina.com/adminapi.php/Home/MakeQr/getExhibitionRr', 
        data, 
        {}).then(res => {
          loading.close();
          if (res.data.type == "1") {
            
            this.imgSrcList = res.data.data.img;
            this.showImgDialogFormVisible = true;
          } else {
            
            if (this.lan == "ch") {
              return this.$message.error({ message: res.text, offset: 120 });
            }
            return this.$message.error({ message: res.text_en, offset: 120 });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    
    changeImgSrc(index){
        this.imgSrcIndex = index;
    },
    
    // 跨域文件下载
    downloadIamge(url, fileName) {

        url= url.replace(/\\/g, '/');
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        //xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
        xhr.onload = () => {
            if (xhr.status == 200) {

                let data = xhr.response;
                let name = fileName;

                var urlObject = window.URL || window.webkitURL || window;
                var export_blob = new Blob([data]);
                var save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a')
                save_link.href = urlObject.createObjectURL(export_blob);
                save_link.download = name;
                save_link.click();

            }
        };

        xhr.send();
    },
    imgDown(){
        // this.downloadIamge(this.imgSrcList[this.imgSrcIndex], 'pic.jpg')
                location.href = reqest.apiUrl + "/Home/Pub/downloadfile?file_path="+this.imgSrcList[this.imgSrcIndex];
    },
    
    cancelImg(){
      this.showImgDialogFormVisible = false;
    },
  }
};
</script>
<style>
.dislogCon .el-dialog__header {
  position: relative;
}
.dislogCon .el-dialog__headerbtn {
  top: 9px;
  right: 0;
}
</style>

<style scoped>

  .experience >>> .el-pagination .el-pager li{
    width: 30px;
    height: 30px;
    line-height: 30px;
    background:none;
    font-size: 14px;
  }
  .experience >>> .el-pagination .btn-next{
    width: 30px;
    height: 30px;
    line-height: 30px;
    background: none;
  }
  .experience >>> .el-pagination .btn-prev{
    width: 30px;
    height: 30px;
    line-height: 30px;
    background: none;
  }
  .experience >>> .el-pagination .el-input__inner{
    width: 30px;
    height: 30px;
    line-height: 25px;
    margin-top: -15px !important;
  }
  .experience >>> .el-pagination .el-pagination__jump{
    width: 25px;
    height: 25px;
    line-height: 25px;
  }
.prompt-info{
  height:30px;
  line-height:30px;
  background:#fff;
  padding-left:15px;
  color:#ed6c00;
  font-size:16px;
  font-weight:bold;
}
.prompt-info span{
  color:#0f408a;
  cursor:pointer;
}
.dislogCon{
  text-align: center;
}
.img-formBtn{
  /* margin: 0 auto;
  text-align: center; */
  text-align: right;
  margin-top: 30px;
  margin-right: 20px;
}
.img-down-formBtn{
    background: #ff9e00;
    width: 100px;
    height: 40px;
    color: #ffffff;
    border: none;
    font-size: 18px;
}
.img-camcale-formBtn{
    background: #cccccc;
    width: 100px;
    height: 40px;
    color: #ffffff;
    border: none;
    font-size: 18px;
}


.img-wrap{
    width: 100%;
    padding: 20px 0;
    display: flex;
}
.img-wrap-left{
    flex: 1;
    padding: 20px;
    border-radius: 20px;
    min-height: 500px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ececec;
}
.choose-img{
    width: 300px;
    text-align: center;
    margin: 0 auto;
}
.img-wrap-right{
    flex: 2.5;
    margin: 0 auto;
    padding-top: 20px;
}
.img-wrap-right-top{
    display: inline-block;
    margin-top: 20px;
}
.img-wrap-right-top img{
    width: 150px;
}
.img-wrap-right-top-div{
    /* display: inline-block; */
    float: left;
    height: 290px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 3px solid #ececec;
    margin: 0 10px;
    position: relative;
}
/* .img-right{
    display: none;
} */
.img-right{
    position:absolute;
    right: 0;
    bottom: 0;
    padding: 0 !important;
    width: 30px !important;
    height: 30px;

}
.img-wrap-right-top-div img{

    padding: 20px 10px;
}
.img-wrap-right-top-div-active{
    border: 3px solid #ff9e00;
}
.img-wrap-title{
    width: 150px;
    margin: 0 auto;
    position: relative;
    z-index: 9;
}
.img-wrap-title p{
    color: #212c67;
    font-size: 1.3rem;
    z-index: 9;
}

.div-border-bottom-color{
    width: 150px;
    height: 3px;
    background: #c7d0f2;
    position: absolute;
    left: 0;
    bottom: 1px;
    z-index: -1;
}
</style>